import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../core/url-params.model';

export class ContractsHttpUtil {

  public static prepareParamsContracts(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.pageSize) {
      urlParams.append('pageSize', params.pageSize);
    }
    if (params.pageNumber || params.pageNumber === 0) {
      urlParams.append('pageNumber', params.pageNumber);
    }
    if (params.showClosed || params.showClosed === 0) {
      urlParams.append('showClosed', params.showClosed);
    }
    if (params.address) {
      urlParams.append('address', params.address);
    }
    if (params.cadastre) {
      urlParams.append('cadastre', params.cadastre);
    }
    if (params.docNum) {
      urlParams.append('docNum', params.docNum);
    }
    if (params.docDate) {
      urlParams.append('docDate', params.docDate);
    }
    return urlParams;
  }

  public static prepareParamsDownload(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.formatType) {
      urlParams.append('formatType', params.formatType);
    }
    if (params.contractId) {
      urlParams.append('contractId', params.contractId);
    }
    if (params.startDate) {
      urlParams.append('startDate', params.startDate);
    }
    if (params.endDate) {
      urlParams.append('endDate', params.endDate);
    }
    return urlParams;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/contracts.util.ts